module.exports = __webpack_public_path__ + "static/media/8.question.8e45905f.mp4";